import MuiButton from './MuiButton';
import MuiCard from './MuiCard';
import MuiCardActions from './MuiCardActions';
import MuiCardContent from './MuiCardContent';
import MuiCardHeader from './MuiCardHeader';
import MuiChip from './MuiChip';
import MuiIconButton from './MuiIconButton';
import MuiInputBase from './MuiInputBase';
import MuiLinearProgress from './MuiLinearProgress';
import MuiListItem from './MuiListItem';
import MuiListItemIcon from './MuiListItemIcon';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPaper from './MuiPaper';
import MuiTableCell from './MuiTableCell';
import MuiTableHead from './MuiTableHead';
import MuiTableRow from './MuiTableRow';
import MuiToggleButton from './MuiToggleButton';
import MuiTypography from './MuiTypography';

export default {
  MuiButton: { styleOverrides: MuiButton },
  MuiCard: { styleOverrides: MuiCard },
  MuiCardActions: { styleOverrides: MuiCardActions },
  MuiCardContent: { styleOverrides: MuiCardContent },
  MuiCardHeader: { styleOverrides: MuiCardHeader },
  MuiChip: { styleOverrides: MuiChip },
  MuiIconButton: { styleOverrides: MuiIconButton },
  MuiInputBase: { styleOverrides: MuiInputBase },
  MuiLinearProgress: { styleOverrides: MuiLinearProgress },
  MuiListItem: { styleOverrides: MuiListItem },
  MuiListItemIcon: { styleOverrides: MuiListItemIcon },
  MuiOutlinedInput: { styleOverrides: MuiOutlinedInput },
  MuiPaper: { styleOverrides: MuiPaper },
  MuiTableCell: { styleOverrides: MuiTableCell },
  MuiTableHead: { styleOverrides: MuiTableHead },
  MuiTableRow: { styleOverrides: MuiTableRow },
  MuiToggleButton: { styleOverrides: MuiToggleButton },
  MuiTypography: { styleOverrides: MuiTypography }
};
